import {
  Flexbox, ListManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'
import CardHeader from '../components/CardHeader'
import CardItem from '../components/CardItem'

function ClinicalCaresByClassification({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByClassification, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por classificação"
        subtitle="Quantidade de atendimentos clínicos por classificação"
        icon="fas fa-tags"
        rightAction={() => <FilterClinicalCares />}
      />
      <ListManager count={data?.rows?.length || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <Flexbox.Columns>
            {data.rows.map((item) => (
              <Flexbox.Column key={item?.classificationId || 'without-classification'} className="col-6 col-sm-12 my-2">
                <CardItem
                  item={item}
                  statusList={data?.statusList}
                  header={(
                    <CardHeader
                      icon="fas fa-tag"
                      title={item?.description || 'Atendimentos sem classificação'}
                    />
                  )}
                />
              </Flexbox.Column>
            ))}
          </Flexbox.Columns>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByClassification
